common.View.create('crud::components.DisplayAction', {

    tableKey: null,

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
        // TODO: Change event BEFORE drawing the table?
        $(document).on( 'init.dt', ( e, settings ) => {
            // Load js
            common.View.reinit();

            this.tableKey = this.element.data('table-key')+"-active-columns";

            this.initDisplay();

            let table = $('#dataTableBuilder').DataTable();
            table.on( 'draw', () => {
                // Datatable ready loading
                common.View.reinit();

                this.initDisplay();
            });
        });
	},

    initDisplay() {
        // TODO: Refactor and split up more?
        // Define table data
        let table = $('#dataTableBuilder');
        let columns = $('.displayDropdown .displayAction');

        this.initialLoad(table, columns);

        columns.each((key, val) => {
            // Remove hidden from rowReorder
            table.find('.rowReorder').removeClass('hidden');

            $(val).click((event) => {
                // Set checked values in localStorage
                this.loadCheckedItems();

                // Find column name
                let columnName = $(event.currentTarget).data('column');

                if($(event.currentTarget).is(':checked')) {
                    table.find('.'+columnName).removeClass('hidden');
                } else {
                    table.find('.'+columnName).addClass('hidden');
                }
            });
        });
	},

    initialLoad(table, columns) {
        let storageValues = [];

        if(!localStorage.getItem(this.tableKey)) {
            $('.displayDropdown .displayAction').each(function(index, input) {
                storageValues.push($(input).data('column'));
            });
            localStorage.setItem(this.tableKey, storageValues);

            columns.each((key, val) => {
                $(val).attr('checked', true);
            });
        }

        table.find('th, td').addClass('hidden');

        $.each(localStorage.getItem(this.tableKey).split(','), function(key, value){
            columns.filter((key, val) => {
                return $(val).data('column') === value;
            }).prop('checked', true);

            table.find('.'+value).removeClass('hidden');
        });
    },

    loadCheckedItems() {
        let checkedItems = [];

        $('.displayDropdown .displayAction:checked').each(function(index, input) {
            checkedItems.push($(input).data('column'));
        });

        localStorage.setItem(this.tableKey, checkedItems);
    },

});
